import React from 'react';
import { Alert } from '@mui/material';

interface OfflineBannerProps {
  isOnline: boolean;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({ isOnline }) => {
  if (isOnline) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }}>
      You are offline. Changes cannot be saved.
    </Alert>
  );
};

export default OfflineBanner;
